export default "__VITE_ASSET__C9pnFPw3__"